'use client';


/** Imports */
import React from 'react';
import classNames from 'classnames';
import styles from './button.module.css';


/** Types */
type Variant = 'primary' | 'secondary' | 'danger' | 'large';
type Props = Readonly<
    React.ComponentPropsWithoutRef<'button'> &
    {
        variant?: Variant | Array<Variant>;
        label?: React.ReactNode;
        centerLabel?: boolean
    }
>;


/** Component */
export default function Button(props: Props) {
    const {children, label, centerLabel, variant, ...nativeProps} = props;
    const variants = (Array.isArray(variant))
        ? ((variant.length > 0)
            ? variant
            : ['primary' as Variant])
        : ((variant)
            ? [variant]
            : ['primary' as Variant]);
    return (
        <button
            {...nativeProps}
            className={classNames(
                styles.button,
                ...(variants.map((variant) => styles[variant])),
                {[styles.centerLabel]: centerLabel},
                {[styles.disabled]: nativeProps.disabled},
                ((props.className)
                    ? props.className
                    : undefined),
            )}
            onClick={
            (!nativeProps.disabled)
                ? nativeProps.onClick
                : undefined
        }
        >
            {children}
            {label}
        </button>
    );
}
